<!--学生详情-->
<template>
  <div id="student-details">
    <a-page-header
      title="学生详情"
      :backIcon="false">
      <template slot="extra">
        <a-button key="1" @click="back">
          更换学生
        </a-button>
      </template>
      <div class="content">
        <!--2020-1-24 黄叫删除接口没返回（地区、所在学校、所在年级、详细地址）-->
        <a-descriptions :column="3">
          <a-descriptions-item label="姓名">{{ userInfo.realName }}</a-descriptions-item>
          <a-descriptions-item label="年级">{{ userInfo.gradeName }}</a-descriptions-item>
          <a-descriptions-item label="手机号">{{ userInfo.mobile }}</a-descriptions-item>
          <a-descriptions-item label="性别">
            {{ userInfo.gender === 1 ? '男' : '女' }}
          </a-descriptions-item>
          <a-descriptions-item label="班级">{{ userInfo.classes.map(v => v.className).join("，") }}</a-descriptions-item>
          <a-descriptions-item label="所属机构">{{ userInfo.organizationName }}</a-descriptions-item>
          <a-descriptions-item label="出生日期">{{ userInfo.birthday }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-page-header>
    <div class="page-content">
      <div>
        <!-- <h3>
            {{ organizationUserDto.realName }}的课程信息
            <a-button @click="getCourseConfigList" style="float: right;" type="primary" html-type="button">
                开通课程
            </a-button>
        </h3> -->
        <!-- <div style="text-align: left;margin-bottom: 15px;">
          <a-button v-permission="`pStudentDetails.Open`" @click="getCourseConfigList(1)" type="primary"
                    html-type="button">
            开通课程
          </a-button>
        </div> -->
        <a-table
          style="min-width: 300px;"
          :customRow="customRow"
          :columns="courseColumns"
          row-key="projectCourseUserId"
          :pagination="courseTableRelevant.tablePagination"
          :loading="courseTableRelevant.tableLoading"
          :locale="courseTableRelevant.locale"
          :dataSource="courseTableRelevant.tableDataSource">
          <div slot="code" slot-scope="text, record" v-if="!!text.code">
            <a-button @click.stop="copy(text.code)" type="link">{{ text.code }}</a-button>
          </div>
          <div slot="progress" slot-scope="text, record">
            {{ text.progress }}%
          </div>
        </a-table>
      </div>
      <div>
        <h3>{{ courseChildTit }}的课时信息</h3>
        <a-table
          style="min-width: 300px;"
          :columns="classHourColumns"
          row-key="courseChildId"
          :pagination="classHourTableRelevant.tablePagination"
          :loading="classHourTableRelevant.tableLoading"
          :locale="classHourTableRelevant.locale"
          :dataSource="classHourTableRelevant.tableDataSource">
          <div slot="progress" slot-scope="text, record">
            {{ text.progress }}%
          </div>
          <div slot="status" slot-scope="text, record">
            {{text.userChildCourseEnabled ? '启用' : '禁用'}}
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="link" @click="lookResult(text)"
                      :disabled="text.progress == 0 || !text.userChildCourseEnabled" icon="unordered-list">查看结果</a-button>
          </div>
        </a-table>
      </div>
    </div>

    <a-modal :centered="true" v-model="openCourse.visible" :confirm-loading="openCourse.confirmLoading" title="开通课程"
             @ok="openCourseOk" width="700px">
      <a-form-model layout="inline" :model="openCourse.search" style="margin-bottom: 20px;">
        <a-form-model-item label="课程名称">
          <a-input allow-clear :maxLength="30" v-model="openCourse.search.courseName" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getCourseConfigList(1)" type="primary" html-type="button">
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table :row-selection="rowSelection"
               :columns="courseConfigListColumns"
               row-key="id"
               :pagination="courseConfigList.tablePagination"
               :loading="courseConfigList.tableLoading"
               :locale="courseConfigList.locale"
               :dataSource="courseConfigList.tableDataSource">
        <div slot="name" slot-scope="text">{{ text.name + ' - ' + text.period }}</div>
      </a-table>
    </a-modal>
    <!--教师评价-->
    <TeacherEvaluation v-model="evaluate.visible" :page-info="evaluate.pageInfo"></TeacherEvaluation>
  </div>
</template>

<script>
import {tableRelevant, SecondsToTime} from "@/pages/projectImpl/js/utils";
import $Bus from "@/pages/projectImpl/js/eventBus";
import TeacherEvaluation from "./components/TeacherEvaluation";

const courseColumns = [
  {
    title: '课程名称',
    dataIndex: 'courseName'
  },
  {
    title: '开课时间',
    dataIndex: 'createTime'
  },
  {
    title: '最近使用时间',
    dataIndex: 'modifyTime'
  },
  {
    title: '完成进度',
    align: "center",
    scopedSlots: {customRender: 'progress'}
  },
  {
    title: '课程码',
    align: "center",
    scopedSlots: {customRender: 'code'}
  }
];

const classHourColumns = [
  {
    title: '课时名称',
    dataIndex: 'courseName'
  },
  {
    title: '课时进度',
    scopedSlots: {customRender: 'progress'}
  },
  {
    title: '用时',
    dataIndex: 'timeConsumingFormat'
  },
  {
    title: '状态',
    scopedSlots: {customRender: 'status'}
  },
  {
    title: '最近完成时间',
    dataIndex: 'modifyTime'
  },
  {
    title: '操作',
    scopedSlots: {customRender: 'action'}
  }
];

const courseConfigListColumns = [
  {
    title: '课程名称',
    scopedSlots: {customRender: 'name'}
  },
  {
    title: '关联课程资源',
    dataIndex: "courseResourceName"
  }
];

export default {
  name: "StudentDetails",
  components: {TeacherEvaluation},
  data() {
    return {
      userInfo: {classes: []},
      courseColumns,
      classHourColumns,
      courseConfigListColumns,
      //课程列表
      courseTableRelevant: tableRelevant.call(this, this.getStudentCourse),
      //课时列表
      classHourTableRelevant: tableRelevant.call(this, this.getStudentClassHour),
      //开通课程列表
      courseConfigList: tableRelevant.call(this, this.getCourseConfigList),
      openCourse: {
        visible: false,
        confirmLoading: false,
        selectedRowKeys: [],
        search: {
          courseName: undefined
        }
      },

      courseChildTit: '',
      projectCourseUserId: undefined,

      evaluate: {
        visible: false,
        pageInfo: {}
      }
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.openCourse.selectedRowKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.source == 1
          },
        }),
        onChange: (selectedRowKeys, selectedRows) => {
          this.openCourse.selectedRowKeys = selectedRowKeys;
        },
      };
    }
  },
  mounted() {
    const arr = ["首页", "项目实施", {
      name: "学生管理",
      path: window.decodeURIComponent(this.$route.query.fullPath)
    }, "用户详情"];
    $Bus.$emit("pageHeaderBreadcrumb", arr);
    this.getStudentDetails();
    this.getStudentCourse();
  },
  methods: {
    customRow(record) {
      return {
        on: { // 事件
          click: () => {
            this.courseChildTit = record.courseName;
            this.projectCourseUserId = record.projectCourseUserId;
            this.getStudentClassHour(1)
          },
        },
      }
    },
    //获取个人信息
    getStudentDetails() {
      this.$http.UserManage.getStudentDetails({
        OrganizationUserId: this.$route.query.id
      }).then(res => {
        const {data} = res;
        this.userInfo = data || {classes: []};
      });
    },
    //获取课程
    getStudentCourse(pageIndex) {
      if (pageIndex) {
        this.courseTableRelevant.tablePagination.current = pageIndex;
      }
      const params = {
        organizationUserId: this.$route.query.id,
        classId: this.$route.query.classId,
        pageIndex: pageIndex || this.courseTableRelevant.tablePagination.current,
        pageSize: this.courseTableRelevant.tablePagination.pageSize
      };
      this.courseTableRelevant.tableLoading = true;
      this.$http.UserManage.getStudentCourse(params).then(res => {
        const {data} = res;
        this.courseTableRelevant.tableDataSource = data.items.map(m => {
            m.modifyTime = m.progress ? m.modifyTime : '--';
            return m;
          });
          this.courseTableRelevant.tablePagination.total = data.totalCount;
          if (data.items.length) {
            this.courseChildTit = data.items[0].courseName;
            this.projectCourseUserId = data.items[0].projectCourseUserId;
            this.getStudentClassHour(1);
          }
      }).finally(() => {
        this.courseTableRelevant.tableLoading = false;
      })
    },
    //获取课时
    getStudentClassHour(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.classHourTableRelevant.tablePagination.current,
        pageSize: this.classHourTableRelevant.tablePagination.pageSize,
        userCourseId: this.projectCourseUserId,
      };
      this.classHourTableRelevant.tableLoading = true;
      this.$http.UserManage.getStudentClassHour(params).then(res => {
        const {data} = res;
        this.classHourTableRelevant.tableDataSource = data.items.map(m => {
            const classEvaluate = [1 << 2, 1 << 3].every(e => (e & m.flag) > 0);
            const teacherEvaluate = [1 << 2, 1 << 3, 1 << 4].every(e => (e & m.flag) > 0);
            return {
              ...m, classEvaluate, teacherEvaluate,
              loading: false,
              modifyTime: m.progress ? m.modifyTime : '--',
              timeConsumingFormat: SecondsToTime(m.timeConsuming),
              courseStatus: m.progress <= 0 ? "未开始" : m.progress >= 100 ? "已完成" : "进行中"
            }
          });
          this.classHourTableRelevant.tablePagination.total = data.totalCount;
          this.classHourTableRelevant.tablePagination.current = data.pageIndex;
      }).finally(() => {
        this.classHourTableRelevant.tableLoading = false;
      })
    },

    //返回学生列表
    back() {
      this.$router.push(window.decodeURIComponent(this.$route.query.fullPath));
    },

    //课程码
    lookResult(val) {
      console.log(val);
      this.evaluate.pageInfo = val;
      this.evaluate.visible = true;
    },
    //获取开通课程列表
    getCourseConfigList(pageIndex) {
      this.openCourse.visible = true;
      const params = {
        organizationId: this.$route.query.organizationId,
        OrganizationUserId: this.$route.query.id,
        pageIndex: pageIndex || this.courseConfigList.tablePagination.current,
        pageSize: this.courseConfigList.tablePagination.pageSize,
        ...this.openCourse.search
      };
      this.courseConfigList.tableLoading = true;
      this.$http.UserManage.getCourseConfigList(params).then(res => {
        const {data} = res;
        this.courseConfigList.tableDataSource = data.items;
          this.courseConfigList.tablePagination.total = data.totalCount;
          this.courseConfigList.tablePagination.current = data.pageIndex;
          if (Array.isArray(data.items)) {
            data.items.forEach(f => {
              if (f.checked && !this.openCourse.selectedRowKeys.includes(f.id)) {
                this.openCourse.selectedRowKeys.push(f.id);
              }
            })
          }
      }).finally(() => {
        this.courseConfigList.tableLoading = false;
      })
    },
    //开通课程
    openCourseOk() {
      this.$message.destroy();
      let add = [], del = [];
      this.courseConfigList.tableDataSource.forEach(v => {
        if (v.checked) {
          if (this.openCourse.selectedRowKeys.indexOf(v.id) === -1) {
            del.push({
              // "CourseId": v.courseId,
              "projectCourseConfigId": v.id,
              "projectCourseResourceId": v.projectCourseResourceId
            });
          }
        } else {
          if (this.openCourse.selectedRowKeys.indexOf(v.id) > -1) {
            add.push({
              // "CourseId": v.courseId,
              "projectCourseConfigId": v.id,
              "projectCourseResourceId": v.projectCourseResourceId
            });
          }
        }
      });
      if (!(add.length || del.length)) {
        this.$message.warn("请选择课程");
        return
      }
      const params = {
        organizationUserId: this.$route.query.id,
        addProjectCourseConfigs: add,
        cancelProjectCourseConfigs: del
      };
      this.openCourse.confirmLoading = true;
      this.$http.UserManage.openCourse(params).then(res => {
        const {message} = res;
        this.$message.success(message);
          this.openCourse.visible = false;
          setTimeout(this.getStudentCourse(1), 1000);
      }).finally(() => {
        this.openCourse.confirmLoading = false;
      })
    },
    copy(val) {
      this.$message.destroy();
      try {
        if (window.clipboardData) {
          window.clipboardData.setData('text', val);
        } else {
          (function (s) {
            document.oncopy = function (e) {
              e.clipboardData.setData('text', s);
              e.preventDefault();
              document.oncopy = null;
            }
          })(val);
          document.execCommand('Copy');
        }
        this.$message.success("复制成功");
      } catch (e) {
        this.$message.error("复制失败，请手动复制！");
      }
    },
  }
}
</script>

<style scoped lang="less">
#student-details {
  background-color: #fff;
  margin: -110px -24px 0;
  .page-content {
    display: flex;
    justify-content: space-between;
    //margin-top: 30px;
    padding: 24px;
  }

  .page-content > div {
    width: 49%;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 20px;
  }

  h3 {
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
  }
}

.select-class-form {
  height: 60px;

  .ant-form-inline .ant-form-item-with-help {
    margin-bottom: 0;
  }
}

tr:last-child td {
  padding-bottom: 0;
}

.content .ant-statistic {
  text-align: center;
}

.content .ant-statistic-content {
  font-size: 20px;
  line-height: 28px;
}

.active {
  color: #f90;
}

@media (max-width: 576px) {
  .content .content {
    display: block;
  }
}
</style>
